const hostname = window.location.hostname;

if (['localhost', '127.0.0.1'].includes(hostname)) {
  window.env = 'local';
} else if (hostname.includes('dev.')) {
  window.env = 'dev';
} else {
  window.env = 'prod';
}

window.isLocal = window.env === 'local';
window.isDev = window.env === 'dev';
window.isProd = window.env === 'prod';
